import { render, staticRenderFns } from "./TxtSub.vue?vue&type=template&id=9605f0aa&functional=true&"
import script from "./TxtSub.vue?vue&type=script&lang=js&"
export * from "./TxtSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports